import React from 'react';
import PropTypes, { InferProps } from 'prop-types';

const propTypes = {
  defaultValue: PropTypes.string,
  filterOptions: PropTypes.array,
  handleChange: PropTypes.func,
  handleFilterChange: PropTypes.func,
};

export default function SearchForm(
  props: InferProps<typeof propTypes>,
): JSX.Element {
  const { defaultValue, filterOptions, handleChange, handleFilterChange } = props;

  return (
    <div>
      <div className="keyword-search">
        <label className="keyword-search__label" htmlFor="searchbox">
          Keyword Search
        </label>
        <input
          className="keyword-search__input"
          id="searchbox"
          defaultValue={defaultValue}
          onChange={handleChange}
          placeholder="Enter search term"
        />
        <div className="keyword-search__filters">
          <div className="filter">
            <label htmlFor="sector-filter">Sector</label>
            <select
              name="sectors"
              id="sector-filter"
              onChange={handleFilterChange}
            >
                <option value=''>Select one..</option>
                {filterOptions.map((data, index) => (
                  <option key={index} value={data}>{data}</option>
                ))}
            </select>
          </div>
          <div className="filter">
            <label>Expiration status</label>
            <select
              name="expired"
              onChange={handleFilterChange}
              id="expiration-filter"
            >
              <option key="null-option" value="">Select one..</option>
              <option key="expired" value="Expired">Expired</option>
              <option key="in-force" value="In force">In force</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}
